import React from 'react'
import { fadeIn } from '../variants';
import Footer from './Footer'
import { motion } from 'framer-motion';

const NotFound = () => {
  return (
    <div id='404' className='flex flex-col justify-between items-center h-screen'>
      <div className='flex flex-col justify-center items-center text-center h-full'>
        <motion.h1
        variants={fadeIn('down', 0.3)}
        initial="hidden"
        whileInView={'show'}
        viewport={{ once: false, amount: 0.7 }}
        className='text-8xl pb-4'>
          ERROR 404
        </motion.h1>

        <motion.p
        variants={fadeIn('up', 0.5)}
        initial="hidden"
        whileInView={'show'}
        viewport={{ once: false, amount: 0.7 }}
        className='text-4xl'>
          PÁGINA NO ENCONTRADA 😢
        </motion.p>
      </div>
      <Footer />
    </div>
  );
}

export default NotFound